export default "__VITE_ASSET__DqwNR9VB__"